import React, { useEffect }  from "react";
import { connect } from "react-redux";
import Card from "components/card";
import { Form } from 'antd';
import FarmProfileFields from "./FarmProfileFields";
import { 
	getFarmProfileDetails, doFarmProfileCreate, doFarmProfileUpdate 
} from "../../../../redux/farmprofile/farmProfileState";
import { useForm } from 'antd/lib/form/Form';
import CrudButtons from "components/button/crudbuttons";

const FarmProfileForm = ({recordId, getRecord, mode, doCreate, doUpdate, recordData, requesting, success, myFarmerProfile, farmerId, ...props}) => {
	 	
	const [form] = useForm();
	
	useEffect(() => {
		getRecord(recordId);
	}, [recordId, getRecord]);
	
	useEffect(() => {
		if(recordData){
			const { ...restData } = recordData;
			const initialValues = {
				...restData,	            
			};
			
			form.setFieldsValue(initialValues);
		}
	}, [recordData, form]);
	
	const onSubmit = (formData) => {	
		try {  
			//formData.farmer_id = myFarmerProfile.id;
			recordData.id > 0 ? doUpdate(formData): doCreate(formData); 
		} catch (error) {
			console.error('Save failed:', error);
		}
	};

	return (
		<Card extra={"w-full h-full p-4"}>
			<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
				layout="vertical"
				onFinish={onSubmit}
			>   
				<FarmProfileFields recordData={recordData} mode={mode}/>

				<CrudButtons baseRoute="/console/farmer-informations" 
					mode={mode} 
					recordId={farmerId} 
					cancelLabel="Back"/>
			</Form>	 	
		</Card>
    );
};

const mapStateToProps = (state) => ({
	recordData: state.farmProfile.details?.data,
	requesting: state.farmProfile.details?.requesting,
	success: state.farmProfile.details?.success,
	myFarmerProfile: state.farmProfile.details?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getFarmProfileDetails(id)),
	doCreate: (data) => dispatch(doFarmProfileCreate(data)),
	doUpdate: (data) => dispatch(doFarmProfileUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FarmProfileForm);